import CheckMarkIcon from './component.jsx'
export default CheckMarkIcon
